<template>
  <div id="jobs">
    <div class="jobs-title">
      <h2>Jobs</h2>
    </div>
    <ul class="list-types-jobs">
						<li><a href="#">Todos</a></li>
						<li><a href="#">Aplicativos</a></li>
						<li><a href="#">Sites</a></li>
						<li><a href="#">Sistemas</a></li>
						<li><a href="#">Loja Virtual</a></li>
						<li><a href="#">WordPress</a></li>
					</ul>
    <section id="cards-jobs">
      <div class="cards">
        <img src="../assets/escola.webp" alt="">
      </div>
      <div class="cards">
        <img src="../assets/sistemIgreja.webp" alt="">
      </div>
       <div class="cards">
         <img src="../assets/foodfy.webp" alt="">
      </div>
       <div class="cards">
         <img src="../assets/app.webp" alt="">
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods:{
  modal(){
    const modalOverlayCursos = document.querySelector('.modal-overlay-cursos')
    const modal = document.querySelector(".modal-curso")
    const cardsCursos = document.querySelectorAll('.card-card');

    for (let cardCard of cardsCursos){
      cardCard.addEventListener("click", function(){
        modalOverlayCursos.classList.add("active")
        const cursoId = cardCard.getAttribute("id")
        modalOverlayCursos.querySelector("iframe").src = `https://rocketseat.com.br/${cursoId}`
      })
    }

    //////////////////
    document.querySelector('.close-modal-curso').addEventListener("click", function(){
      modalOverlayCursos.classList.remove("active")
      modalOverlayCursos.querySelector("iframe").src = ""

      
    })

    document.querySelector(".maximize-modal").addEventListener("click", function () {
        modal.classList.toggle("maximize")
        modal.classList.remove("maximize")
      })
      }
      }

    }
</script>

<style scoped>
#jobs{
  margin-top: 15%;
}
.list-types-jobs{
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap:20px;
  margin-bottom:3%;
  cursor: pointer;
  font-size: 1rem;
  text-transform: uppercase;
}
.list-types-jobs li a{
  font-weight: 700;
  color:var(--color-principal)
}
.list-types-jobs a:hover{
  border-bottom: 3px solid var(--color-secundaria);
}
#cards-jobs{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap:24px;
    margin: 0 50px;
    
  }
.cards img{
    border-radius: 5px;
  }
.jobs-title h2 {
  padding-bottom: 5%;
  text-align: center;
  font-size: 2.5rem;
  line-height: 4rem;
  color: #4070f4;
}

/*MODAL*/

/*===Modal===*/

.modal-overlay {
  background-color: rgba(0,0,0,0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  opacity: 0;
  visibility: hidden;
}
.modal {
  background-color: #ffff;
  width: 90%;
  height: 90%;
  margin: 5vh auto;
  position: relative;
}

.modal .close-modal {
  color: #222;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
}

/*===Modal.Active===*/
.modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

iframe {
  width: 100%;
  height: 90%;
  position: absolute;
  top:5%;
}

@media (max-width:700px){
  #jobs{
  margin-top: 50%;
}
   #cards-jobs{
     flex-direction: column;
   }
   .list-types-jobs {
   
    flex-direction: column;
     
   }
}
</style>